<template>
    <div class="authorization-form">
        <h2>个人原创作品授权书</h2>

        <div class="form-section">
            <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本人【<span>{{ userName }}</span>】自愿参与【北京整合医学学会】（以下简称"主办方"）组织的【健康中国行动——百姓健康卫士公益科普"百姓巡常行"项目健康科普作品征集活动】，现就投稿作品授权事宜声明如下：
            </p>
        </div>

        <div class="form-section">
            <h3>一、作品信息</h3>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作品名称：<span class="underline filled">{{ worksName }}</span></p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;内容形式：<span class="underline filled">{{ formatWorksType }}</span></p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;创作时间：<span class="underline filled">{{ workTime }}</span></p>
        </div>

        <div class="form-section">
            <h3>二、授权声明</h3>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.本人保证本作品系独立原创，不侵犯他人肖像权、著作权、商标权等任何第三方合法权益，且未以任何形式向任何第三方转让或许可作品的知识产权。若出现权利纠纷，由本人承担全部法律责任。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.本人授予主办方对本作品在全球范围内永久性的独家著作权使用许可（包括发表权、署名权、修改权、保护作品完整权、复制权、发行权、出租权、展览权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权和汇编权等所有著作权利），授权范围包括但不限于：</p>
            <ul>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在学会官网、微信公众号、项目专属云平台及宣发矩阵进行发布</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过合作媒体、短视频平台等第三方渠道进行传播</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用于公益性科普宣传、学术交流等非营利活动</li>
            </ul>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本人同意主办方在上述使用范围内，根据需要对作品进行必要的修改和改编，不得损害作品的完整性和作者的声誉。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;许可方式：独占许可</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;许可期限：永久</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.本人不得再向其他公开渠道公布本作品，不得将本作品的上述权利再授权给任何其他主体，也不得自行使用上述权利进行营利性活动。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.主办方有权再许可他人行使上述权利。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.主办方有权取得行使上述权利所产生的全部收益，本人承诺不向主办方主张其取得的任何收益。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.本人可根据主办方制定的活动规则获得主办方支付的奖励与荣誉，除此之外，就本授权书约定的授权，主办方及相关方无需向本人支付任何其他费用，支付上述费用亦不构成授权生效的前提。</p>
        </div>

        <div class="form-section">
            <h3>三、其他承诺</h3>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.本人保证具有签署本授权书并履行相应义务的权利。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.本人保证所有授权作品的版权和内容符合主办方要求；主办方对作品版权的审核行为不减免本人的任何责任。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.若发现作品存在侵权问题，主办方有权立即下架并追回全部相关荣誉及奖励。本人应在接到通知后立即采取措施解决侵权问题。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.本人承诺所授权作品不侵犯他人合法权利，并符合国家有关法律法规。若授权作品与第三人包括有关国家管理部门发生任何争议、争议的解决以及由此产生的后果均由本人负责和承担，如因此给主办方造成任何损失的，由本人向主办方全额赔偿。</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.本授权书自本人签署之日起生效。</p>
        </div>

        <div class="form-section signature-section">
            <div class="signature-content">
            <p>授权方签字：
                <span class="underline">
                    <img v-if="signatureImage" :src="signatureImage" alt="签名" style="width: 150px; height: 50px;" />
                </span>
            </p>
                <p>联系电话：<span class="underline filled">{{ userPhone }}</span></p>
                <p>签署日期：<span class="underline filled">{{ currentDate }}</span></p>
            </div>
        </div>

        <!-- 电子签名弹窗 -->
        <div v-if="showSignaturePad" class="signature-modal">
            <div class="signature-modal-content">
                <h3>请在此处签名</h3>
                <canvas ref="signaturePad" width="500" height="300" class="signature-canvas"></canvas>
                <div class="signature-buttons">
                    <button @click="saveSignature">保存</button>
                    <button @click="clearSignature">清除</button>
                    <button @click="closeSignaturePad">关闭</button>
                </div>
            </div>
        </div>
        <div class="StepBtns">
                <div class="StepBtn" @click="ToggleStep('prve')" :class="{StpepDisabled:ConfigDisabled}">上一步</div>
                <div class="StepBtn" @click="handleSignClick" :class="{StpepDisabled:ConfigDisabled}">签字</div>
                <div class="StepBtn" @click="ToggleStep('next')" :class="{StpepDisabled:ConfigDisabled}">提交</div>
        </div>
    </div>
</template>

<script>
import SignaturePad from 'signature_pad';
import html2pdf from 'html2pdf.js';
import axios from 'axios';
import Global from '@/common/Global.vue'; 
    export default {
        inject: ['worksInfo', 'isEdit', 'formData'],
        data() {
            return {
                ID:"",
                EdiId:"",
                SetData:{
                    file:"",
                    video_file:"",
                    password:"",
                },
                FormData:[],
                ConfigDisabled:false,
                signaturePad: null,
                showSignaturePad: false,
                signatureImage: null,
                userName: '',        // 作者姓名
                worksName: '',       // 作品名称
                worksType: '',       // 作品形式
                workTime: '',        // 创作时间
                userPhone: '',       // 联系电话
                currentDate: '',      // 当前日期
                isMobile: false      // 是否是移动设备
            }
        },
        props:{
            id:"",
            TypeId:"",
            PageDisabled:false,
            user_group_id:"",
        },
        created() {
            // 在创建组件时设置当前日期
            this.setCurrentDate();
            this.$axios = axios;
            // 将 Global 挂载到 Vue 实例上
            this.$Global = Global;
            
            // 检测设备类型
            this.checkDeviceType();
            // 监听窗口大小变化
            window.addEventListener('resize', this.checkDeviceType);
        },
        beforeDestroy() {
            // 移除窗口大小变化监听器
            window.removeEventListener('resize', this.checkDeviceType);
            window.removeEventListener('resize', this.resizeSignaturePad);
        },
        mounted() {
            this.ID = this.id || '';
            this.ConfigDisabled = this.PageDisabled;

            // 获取前面页面填写的数据
            const formData = this.formData && this.formData();

            if (formData && formData.basicInfo) {
                // 填充基本信息
                this.userName = formData.basicInfo.userName || '';
                this.userPhone = formData.basicInfo.userPhone || '';
            }

            if (formData && formData.specialtyInfo) {
                // 填充专业信息
                this.worksName = formData.specialtyInfo.worksName || '';
                this.worksType = formData.specialtyInfo.worksType || [];
                this.workTime = formData.specialtyInfo.workTime || '';
            }

            // 如果是编辑模式，使用编辑数据
            if (this.isEdit && this.isEdit()) {
                const info = this.worksInfo && this.worksInfo();
                if (info) {
                    this.userName = info.userName || this.userName;
                    this.worksName = info.worksName || this.worksName;
                    this.worksType = info.worksType || this.worksType;
                    this.workTime = info.workTime ? info.workTime.split('T')[0] : this.workTime;
                    this.userPhone = info.userPhone || this.userPhone;
                    
                    if (info.signature) {
                        this.signatureImage = info.signature;
                    }
                }
            }

            // 保留原有的其他逻辑
            if(this.$route.query.type){
                this.ConfigDisabled = false;
                var InfoData = JSON.parse(localStorage.getItem("InfoData"));
                if (InfoData) {
                    this.ID = InfoData.id ? {id: InfoData.id} : {id: ''};
                    this.EdiId = InfoData.case && InfoData.case[0] && InfoData.case[0].id;
                    this.SetData = {
                        file: InfoData.case && InfoData.case[0] && InfoData.case[0].file || '',
                        video_file: InfoData.case && InfoData.case[0] && InfoData.case[0].video_file || '',
                        password: InfoData.case && InfoData.case[0] && InfoData.case[0].password || '',
                    };
                }
            }

            // 设置当前日期
            this.setCurrentDate();
        },
        methods: {
            // 检测设备类型
            checkDeviceType() {
                this.isMobile = window.innerWidth <= 768; // 如果宽度小于等于768px认为是移动设备
            },
            openSignaturePad() {
                this.showSignaturePad = true;
                this.$nextTick(() => {
                    const canvas = this.$refs.signaturePad;
                    
                    // 根据设备类型调整签名板配置
                    const options = {
                        penColor: 'rgb(0, 0, 0)',
                        backgroundColor: 'rgb(255, 255, 255)',
                        throttle: 16 // 提高响应速度
                    };
                    
                    // 调整移动设备上的canvas尺寸
                    if (this.isMobile) {
                        // 设置为父容器宽度的90%
                        const containerWidth = canvas.parentElement.clientWidth * 0.9;
                        canvas.width = containerWidth;
                        canvas.height = containerWidth * 0.6; // 保持合适的宽高比
                        
                        // 添加移动设备特定设置
                        options.velocityFilterWeight = 0.6; // 调低以减少延迟
                    }
                    
                    // 初始化SignaturePad
                    this.signaturePad = new SignaturePad(canvas, options);
                    
                    // 添加窗口调整事件监听
                    window.addEventListener('resize', this.resizeSignaturePad);
                    
                    // 修复iOS设备的触摸事件问题
                    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                        this.fixIOSTouchEvent(canvas);
                    }
                });
            },
            // 修复iOS设备触摸事件问题
            fixIOSTouchEvent(canvas) {
                // 阻止文档触摸事件
                document.body.addEventListener('touchstart', function(e) {
                    if (e.target === canvas) {
                        e.preventDefault();
                    }
                }, { passive: false });
                
                document.body.addEventListener('touchend', function(e) {
                    if (e.target === canvas) {
                        e.preventDefault();
                    }
                }, { passive: false });
                
                document.body.addEventListener('touchmove', function(e) {
                    if (e.target === canvas) {
                        e.preventDefault();
                    }
                }, { passive: false });
            },
            // 重置签名板大小
            resizeSignaturePad() {
                if (!this.signaturePad || !this.$refs.signaturePad) return;
                
                const canvas = this.$refs.signaturePad;
                
                // 保存当前签名数据
                const data = this.signaturePad.toData();
                
                // 根据设备类型调整canvas尺寸
                if (this.isMobile) {
                    const containerWidth = canvas.parentElement.clientWidth * 0.9;
                    canvas.width = containerWidth;
                    canvas.height = containerWidth * 0.6;
                } else {
                    // 保持PC版本尺寸不变或根据需要调整
                    canvas.width = 500;
                    canvas.height = 300;
                }
                
                // 重新初始化签名板
                this.signaturePad.clear();
                
                // 恢复签名数据（如果有）
                if (data && data.length > 0) {
                    this.signaturePad.fromData(data);
                }
            },
            closeSignaturePad() {
                this.showSignaturePad = false;
                // 移除窗口调整事件监听
                window.removeEventListener('resize', this.resizeSignaturePad);
            },
            saveSignature() {
                if (this.signaturePad.isEmpty()) {
                    this.$message.error('请先签名');
                    return;
                }
                const signatureData = this.signaturePad.toDataURL();
                this.signatureImage = signatureData;
                this.closeSignaturePad();
                
                // 保存签名后立即保存当前状态
                this.saveCurrentState();
            },
            // 添加保存当前状态方法
            saveCurrentState() {
                // 获取表单数据
                const formData = this.formData && this.formData();
                if (!formData) return;
                
                // 构建临时状态数据
                const tempState = {
                    signature: this.signatureImage,
                    timestamp: new Date().getTime()
                };
                
                // 将状态保存到本地存储
                localStorage.setItem('authSignatureState', JSON.stringify(tempState));
            },
            clearSignature() {
                if (this.signaturePad) {
                    this.signaturePad.clear();
                }
            },
            UpFile({ file,data}) {
                var fd = new FormData()
                fd.append('file',file);
                this.$Global.FileUpData(fd,(res)=>{
                    this.SetData.file = res.data.url;
                    this.$forceUpdate();
                })
            },
            async ToggleStep(s) {
                if(this.ConfigDisabled) return;
                if(s=="next"){
                    // 检查是否已经签名
                    if (!this.signatureImage) {
                        this.$message.error('请先完成签名');
                        return;
                    }

                    try {
                        // 先生成并上传PDF
                        const pdfUrl = await this.generateAndUploadPDF();
                        
                        // 获取表单数据
                        const formData = this.formData && this.formData();

                        if (!formData || !formData.basicInfo || !formData.specialtyInfo) {
                            this.$message.error('数据不完整，请确保已填写所有必要信息');
                            return;
                        }

                        // 构建提交数据
                        const submitData = {
                            // 基本信息
                            userName: formData.basicInfo.userName,
                            userPhone: formData.basicInfo.userPhone,
                            userUnit: formData.basicInfo.userUnit,           
                            userUnitLevel: formData.basicInfo.userUnitLevel, 
                            userDept: formData.basicInfo.userDept,           
                            userZhiwu: formData.basicInfo.userZhiwu,         
                            userZhicheng: formData.basicInfo.userZhicheng,   
                            userEmail: formData.basicInfo.userEmail,         
                            userArea: formData.basicInfo.userArea,
                            address: (formData.basicInfo.userRegion || []).join(' '), // 将数组转换为空格分隔的字符串
                            userRegion: formData.basicInfo.address || formData.basicInfo.userArea, // 将address赋值给userRegion

                            // 专业信息
                            projectCode: formData.specialtyInfo.projectCode,
                            projectId: formData.specialtyInfo.projectId,
                            projectCase: formData.specialtyInfo.projectCase,
                            worksName: formData.specialtyInfo.worksName,
                            workTime: formData.specialtyInfo.workTime || '', // 直接使用已格式化的日期
                            worksType: formData.specialtyInfo.worksType,
                            des: formData.specialtyInfo.des || '',  // 添加备注字段

                            // 文件字段
                            workFile: formData.specialtyInfo.workFile || '',       // 科普文章
                            workPicFile: formData.specialtyInfo.workPicFile || '', // 科普图画
                            workVedioFile: formData.specialtyInfo.workVedioFile || '', // 科普视频
                            workJzFile: formData.specialtyInfo.workJzFile || '',   // 科普讲座
                            workAuthFile: pdfUrl, // 添加授权书PDF的URL

                            // 签名图片
                            signature: this.signatureImage,

                            // 默认状态
                            status: 0
                        };

                        // 如果是编辑模式，添加ID
                        if (this.isEdit && this.isEdit()) {
                            const info = this.worksInfo && this.worksInfo();
                            if (info) {
                                submitData.id = info.id;
                            }
                        }

                        // 判断是否为草稿模式
                        const isDraft = localStorage.getItem('isDraft') === 'true';
                        const draftId = this.$route.query.draftId;
                        
                        // 判断是编辑还是新增，以及是否为草稿模式
                        let url = '/api/v1/works/addworks';
                        let successMsg = '提交成功';
                        
                        if (this.isEdit && this.isEdit()) {
                            url = '/api/v1/works/editworks';
                            successMsg = '修改成功';
                        } else if (isDraft && draftId) {
                            // 如果是编辑草稿模式
                            url = '/api/v1/works/editworksdraft';
                            successMsg = '草稿修改成功';
                            submitData.id = draftId;
                        }

                        // 调用接口提交数据
                        const res = await this.$post(url, submitData);
                        if (res.data.code === 200) {
                            // 提交成功后清除所有缓存数据
                            localStorage.removeItem('basicInfoData');
                            localStorage.removeItem('specialtyInfoData');
                            localStorage.removeItem('specialtyInfoTemp');
                            
                            this.$message.success(successMsg);
                            setTimeout(() => {
                                // 跳转时添加成功标记参数
                                this.$router.push('/UserInfo?fromSuccess=true');
                            }, 1500);
                        } else if (res.data.code === 500) {
                            // 如果返回500错误码，保存为草稿（包括月提交次数限制等情况）
                            this.$message.warning(res.data.msg || '提交失败，系统将自动为您保存为草稿');
                            
                            // 调用保存草稿接口
                            const draftRes = await this.$post('/api/v1/works/addworksdraft', submitData);
                            if (draftRes.data.code === 200) {
                                // 清除缓存数据
                                localStorage.removeItem('basicInfoData');
                                localStorage.removeItem('specialtyInfoData');
                                localStorage.removeItem('specialtyInfoTemp');
                                
                                this.$message.success('草稿保存成功');
                                setTimeout(() => {
                                    // 跳转到草稿箱
                                    this.$router.push('/UserInfo');
                                }, 1500);
                            } else {
                                this.$message.error(draftRes.data.msg || '草稿保存失败');
                            }
                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                    } catch (error) {
                        this.$message.error('操作失败，请重试');
                    }
                } else {
                    this.$emit("PageBtn", "prve");
                }
            },
            handleSignClick() {
                if (!this.ConfigDisabled) {
                    this.openSignaturePad();
                }
            },
            // 设置当前日期的方法
            setCurrentDate() {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                this.currentDate = `${year}-${month}-${day}`;
            },
            // 新增生成并上传PDF的方法
            async generateAndUploadPDF() {
                const element = document.querySelector('.authorization-form');
                if (!element) {
                    throw new Error('未找到授权书元素');
                }

                // 临时隐藏按钮
                const stepBtns = element.querySelector('.StepBtns');
                const originalDisplay = stepBtns ? stepBtns.style.display : 'flex';
                if (stepBtns) {
                    stepBtns.style.display = 'none';
                }

                try {
                    const opt = {
                        margin: [20, 20, 20, 20],
                        filename: '个人原创作品授权书.pdf',
                        image: { type: 'jpeg', quality: 1 },
                        html2canvas: { 
                            scale: 2,
                            useCORS: true,
                            logging: true,
                            letterRendering: true
                        },
                        jsPDF: { 
                            unit: 'mm', 
                            format: 'a4', 
                            orientation: 'portrait'
                        }
                    };

                    // 生成PDF blob
                    const pdfBlob = await html2pdf()
                        .set(opt)
                        .from(element)
                        .output('blob');

                    // 上传PDF
                    const formData = new FormData();
                    const file = new File([pdfBlob], '个人原创作品授权书.pdf', { type: 'application/pdf' });
                    formData.append('file', file);

                    const response = await this.$axios.post('/common/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (response.data.code === 200) {
                        this.$message.success('授权书生成成功');
                        return response.data.url; // 返回上传后的URL
                    } else {
                        throw new Error(response.data.msg || '授权书生成失败');
                    }
                } finally {
                    // 恢复按钮显示
                    if (stepBtns) {
                        stepBtns.style.display = originalDisplay;
                    }
                }
            },
            initSignature() {
                if (!this.showSignaturePad) return;
                
                this.$nextTick(() => {
                    const canvas = this.$refs.signaturePad;
                    if (!canvas) return;
                    
                    // 判断是否为移动设备
                    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    
                    // 根据设备类型设置画布尺寸
                    if (isMobile) {
                        canvas.width = 300;
                        canvas.height = 200;
                    } else {
                        canvas.width = 400;
                        canvas.height = 200;
                    }
                    
                    // 创建签名板实例
                    this.signaturePad = new SignaturePad(canvas, {
                        backgroundColor: 'white',
                        penColor: 'black',
                        velocityFilterWeight: isMobile ? 0.5 : 0.7,
                        minWidth: isMobile ? 1 : 0.5,
                        maxWidth: isMobile ? 2.5 : 2.0,
                        throttle: isMobile ? 16 : 0,
                    });
                    
                    // 修复移动端触摸偏移问题
                    this.fixTouchOffset(canvas);
                });
            },
            fixTouchOffset(canvas) {
                // 特别针对iOS设备的触摸事件处理
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                if (!isIOS) return;
                
                // 获取画布的位置信息
                const rect = canvas.getBoundingClientRect();
                
                // 监听触摸开始事件
                canvas.addEventListener('touchstart', (e) => {
                    // 阻止默认行为，防止滚动和缩放
                    e.preventDefault();
                    
                    // 修正触摸位置
                    const touch = e.touches[0];
                    const mouseEvent = new MouseEvent('mousedown', {
                        clientX: touch.clientX - rect.left,
                        clientY: touch.clientY - rect.top
                    });
                    canvas.dispatchEvent(mouseEvent);
                }, { passive: false });
                
                // 监听触摸移动事件
                canvas.addEventListener('touchmove', (e) => {
                    e.preventDefault();
                    
                    const touch = e.touches[0];
                    const mouseEvent = new MouseEvent('mousemove', {
                        clientX: touch.clientX - rect.left,
                        clientY: touch.clientY - rect.top
                    });
                    canvas.dispatchEvent(mouseEvent);
                }, { passive: false });
                
                // 监听触摸结束事件
                canvas.addEventListener('touchend', (e) => {
                    e.preventDefault();
                    const mouseEvent = new MouseEvent('mouseup', {});
                    canvas.dispatchEvent(mouseEvent);
                }, { passive: false });
            }
        },
        watch: {
            worksInfo: {
                immediate: true,
                handler(newVal) {
                    if (this.isEdit() && newVal) {
                        const info = this.worksInfo();
                        if (info) {
                            // 可以在这里添加额外的数据更新逻辑
                        }
                    }
                }
            }
        },
        computed: {
            formatWorksType() {
                if (!this.worksType) return '';
                
                const typeMap = {
                    '1': '科普文章',
                    '2': '科普图画',
                    '3': '科普视频',
                    '4': '科普讲座'
                };

                // 如果 worksType 是数组
                if (Array.isArray(this.worksType)) {
                    return this.worksType
                        .map(type => typeMap[type] || '')
                        .filter(Boolean)
                        .join('、');
                }
                
                // 如果 worksType 是逗号分隔的字符串
                if (typeof this.worksType === 'string' && this.worksType.includes(',')) {
                    return this.worksType
                        .split(',')
                        .map(type => typeMap[type.trim()] || '')
                        .filter(Boolean)
                        .join('、');
                }

                // 如果是单个值
                return typeMap[this.worksType] || '';
            }
        }
    }
</script>

<style scoped>
/* PC端样式 */
.signature-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.signature-canvas {
    border: 1px solid #000;
    touch-action: none; /* 阻止触摸事件的默认行为 */
}

.signature-modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    max-width: 90%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.signature-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.signature-buttons button {
    margin: 5px 10px;
    padding: 8px 15px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    background-color: #58C1B6;
    color: white;
    font-size: 14px;
    transition: background-color 0.3s ease;
}

.signature-buttons button:hover {
    background-color: #4BA89E;
}

/* 清除按钮保持红色 */
.signature-buttons button:nth-child(2) {
    background-color: #f56c6c;
}

.signature-buttons button:nth-child(2):hover {
    background-color: #e04f4f;
}

/* 关闭按钮保持灰色 */
.signature-buttons button:last-child {
    background-color: #909399;
}

.signature-buttons button:last-child:hover {
    background-color: #82848a;
}

.StepBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0
}

.StepBtn {
    margin-right: 20px;
    width: 120px;
    text-align: center;
    padding: 7px 15px;
    color: #fff;
    font-size: 18px;
    background: #58C1B6;
    border-radius: 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.StepBtn:hover {
    background: #4BA89E;
}

.StepBtn.StpepDisabled {
    background: #a8d3cf;
    cursor: no-drop;
}

.authorization-form {
    position: relative;
    max-width: 900px;
    min-height: 1200px;
    margin: 0 auto;
    padding: 40px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-family: Arial, sans-serif;
}

h2 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
}

h3 {
    color: #555;
    margin-top: 20px;
    margin-bottom: 10px;
}

.form-section {
    margin-bottom: 20px;
}

p {
    margin: 12px 0;
    line-height: 1.8;
}

.underline {
    display: inline-block;
    min-width: 150px;
    border-bottom: 1px solid #000;
    padding: 0 5px;
}

.underline.filled {
    border-bottom: none;
}

.underline.long {
    width: 300px;
}

ul {
    padding-left: 20px;
    list-style-type: disc;
}

.signature-section {
    position: relative;
    width: 100%;
    margin-top: 40px;
    text-align: right;
    padding-right: 20px;
}

/* 确保签名图片在PDF中正确显示 */
.signature-section img {
    max-width: 150px;
    height: auto;
    display: inline-block;
}

/* 移动端样式 */
@media screen and (max-width: 768px) {
    .authorization-form {
        padding: 20px 15px;
        min-height: auto;
        border: none;
        box-shadow: 0 1px 5px rgba(0,0,0,0.1);
    }
    
    h2 {
        font-size: 18px;
        margin-bottom: 15px;
    }
    
    h3 {
        font-size: 16px;
        margin-top: 15px;
        margin-bottom: 8px;
    }
    
    p {
        font-size: 14px;
        line-height: 1.6;
        margin: 8px 0;
    }
    
    ul {
        padding-left: 15px;
    }
    
    li {
        font-size: 14px;
        line-height: 1.6;
    }
    
    .underline {
        min-width: 120px;
    }
    
    .signature-modal-content {
        width: 90%;
        padding: 15px;
    }
    
    .signature-canvas {
        width: 100% !important;
        height: 200px !important;
    }
    
    .StepBtn {
        width: 100px;
        font-size: 16px;
        padding: 6px 12px;
    }
    
    .signature-section {
        text-align: left;
        padding-right: 0;
    }
    
    .signature-content p {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }
    
    .signature-content .underline {
        flex: 1;
        min-width: 120px;
        margin-left: 10px;
    }
}
</style>